import React, { useCallback, useState, useMemo } from "react";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { TextInput } from "../UIkit";

const useStyles = makeStyles({
  iconCell: {
    padding: 0,
    height: 48,
    width: 48,
  },
  checkIcon: {
    float: "right",
  },
  inputText: {
    display: "flex",
  },
});

const SetMakersArea = (props) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0),
    [id, setId] = useState(""),
    [mid, setMid] = useState(""),
    [name, setName] = useState("");
  const [editingIndex, setEditingIndex] = useState(-1);

  const inputMid = useCallback(
    (event) => {
      setMid(event.target.value);
    },
    [setMid]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const addMaker = (index, mid, name) => {
    if (mid === "" || name === "") {
      return false;
    } else {
      if (index === props.makers.length) {
        props.setMakers((prevState) => [
          ...prevState,
          { id: "", mid: mid, name: name },
        ]);
        //props.setMakers(prevState => [...props.makers, {id:"", mid:mid, name:name}])
        setIndex(index + 1);
        setMid("");
        setName("");
      } else {
        const newMakers = props.makers;
        newMakers[index] = { ...newMakers[index], mid: mid, name: name };
        props.setMakers(newMakers);
        setIndex(newMakers.length);
        setMid("");
        setName("");
      }
      setEditingIndex(-1);
    }
  };

  // const editMaker = (index, mid, name) =>{
  //     setIndex(index);
  //     setMid(mid);
  //     setName(name);
  // }
  const editMaker = (index, mid, name) => {
    setIndex(index);
    setMid(mid);
    setName(name);
    setEditingIndex(index); // 編集中の行をセット
  };

  const deleteMaker = (deleteIndex) => {
    const newMakers = props.makers.filter((item, i) => i !== deleteIndex);
    props.setMakers(newMakers);
  };
  const memoIndex = useMemo(() => {
    setIndex(props.makers.length);
  }, [props.makers.length]);

  return (
    <div aria-label="メーカー展開">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          {/* ヘッダー部分はそのまま */}
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>メーカー名</TableCell>
              <TableCell className={classes.iconCell} />
              <TableCell className={classes.iconCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.makers.length > 0 &&
              props.makers.map((item, i) => (
                <React.Fragment key={i}>
                  {/* 通常の行 */}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {item.mid}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => editMaker(i, item.mid, item.name)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => deleteMaker(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* 編集中の行の場合、入力フィールドをここに表示 */}
                  {editingIndex === i && i !== props.makers.length - 1 && (
                    // <TableRow>
                    //     {/* 入力フィールド */}
                    //     <TableCell colSpan={4}>
                    //         {/* ここにTextInputコンポーネント */}
                    //         {/* ... */}
                    //     </TableCell>
                    // </TableRow>
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div className={classes.inputText}>
                          <TextInput
                            fullWidth={false}
                            label={"ID"}
                            multiline={false}
                            required={true}
                            onChange={inputMid}
                            minRows={1}
                            value={mid}
                            type={"text"}
                          />
                          <TextInput
                            fullWidth={false}
                            label={"販売店名"}
                            multiline={false}
                            required={true}
                            onChange={inputName}
                            minRows={1}
                            value={name}
                            type={"text"}
                          />
                        </div>
                        <IconButton
                          className={classes.checkIcon}
                          onClick={() => addMaker(index, mid, name)}
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        {/* 編集中の行がない場合、入力フィールドを通常通りここに表示 */}
        {(editingIndex === -1 || editingIndex === props.makers.length - 1) && (
          <>
            <div className={classes.inputText}>
              <TextInput
                fullWidth={false}
                label={"ID"}
                multiline={false}
                required={true}
                onChange={inputMid}
                minRows={1}
                value={mid}
                type={"text"}
              />
              <TextInput
                fullWidth={false}
                label={"販売店名"}
                multiline={false}
                required={true}
                onChange={inputName}
                minRows={1}
                value={name}
                type={"text"}
              />
            </div>
            <IconButton
              className={classes.checkIcon}
              onClick={() => addMaker(index, mid, name)}
            >
              <CheckCircleIcon />
            </IconButton>
          </>
        )}
        {/* <div className={classes.inputText}>
                    <TextInput
                        fullWidth={false} label={"ID"} multiline={false} required={true}
                        onChange={inputMid} minRows={1} value={mid} type={"text"}
                    />
                    <TextInput
                        fullWidth={false} label={"カテゴリー名"} multiline={false} required={true}
                        onChange={inputName} minRows={1} value={name} type={"text"}
                    />
                </div>
                <IconButton className={classes.checkIcon} onClick={() => addMaker(index, mid, name)}>
                    <CheckCircleIcon/>
                </IconButton> */}
      </TableContainer>
      <div className="module-spacer--small" />
    </div>
  );
};

export default SetMakersArea;
